module.exports = __webpack_public_path__ + "static/media/csv-icon.d7b1e0c0.svg";